import { useParams } from "react-router-dom";
import { CustomList } from "./CustomList";
import { useEffect, useState } from "react";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { getOneActivityCategory } from "../../../utils/ApiCalls/Mobile/ActivityMasters";

const ShowCustomList = () => {
  const params = useParams();
  const [activityCategory, setActivityCategory] = useState({});
  const [vesselData, setVesselData] = useState({});
  const [, dispatch] = useDataLayerValue();
  useEffect(() => {
    getData(params?.cat);
  }, [params]);

  const getData = async (value) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getOneActivityCategory(value);

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });

    setActivityCategory(data.data);
    setVesselData(data?.vesselData);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <CustomList
      type="shore"
      page_type={"blog_item"}
      category={activityCategory}
      slug={params.id}
    />
  );
};

export default ShowCustomList;
